<template>
  <div class="desktop-home">
    <PaxelboxLanding />
  </div>
</template>

<script>
import LocalStorage from '@/services/localstorage';
import PaxelboxLanding from '@/components/PaxelboxLanding.vue';

export default {
  name: 'DesktopHome',
  components: {
    PaxelboxLanding,
  },
  created() {
    setTimeout(() => this.$root.scrollToAnchor(this.$route.hash), 2000);
  },
  mounted() {
    // checking query paramater overduepayment
    const paramOrderId = this.$route.query.orderid;
    if (paramOrderId !== undefined) {
      this.$store.dispatch('getOverdueDropoffDetail', paramOrderId)
        .then((response) => {
          const { overdueStatus } = response;
          switch (overdueStatus) {
            case 'need_to_pay':
              this.redirectOverdue('form');
              break;
            case 'none':
              this.redirectOverdue('success');
              break;
            case 'expired':
              this.redirectOverdue('expire');
              break;
            default:
              this.redirectOverdue();
              break;
          }
        })
        .catch(() => {
          this.redirectOverdue();
        });
    }
    // checking localstorage overdue
    if (LocalStorage.getOverdue() !== null) {
      LocalStorage.removeOverdue();
    }
  },
  methods: {
    redirectOverdue(page) {
      let urlPage = '/';
      if (page === 'success') {
        urlPage = '/overduepayment/success';
      } else if (page === 'expire') {
        urlPage = '/overduepayment/expire';
      } else if (page === 'form') {
        urlPage = '/overduepayment';
      }
      this.$router
        .push({ path: urlPage })
        .then(() => { this.$router.go(); });
    },
  },
};
</script>
